// frontend/src/askos/CurrentAffairsPage.js
import React, { useEffect, useState, useCallback } from 'react';
import api, { askosAuthHeader } from './askosApi';
import BookmarkButton from './BookmarkButton';

const CurrentAffairsPage = ({ slug }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [source, setSource] = useState('');

    const load = useCallback(() => {
        setLoading(true);
        const params = { limit: 50 };
        if (source) params.source = source;
        api.get(`/tenant/${slug}/askos/current-affairs`, { params, headers: askosAuthHeader() })
            .then(res => setItems(res.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [slug, source]);

    useEffect(() => { load(); }, [load]);

    return (
        <div className="subpage">
            <h2>Current Affairs</h2>

            <div className="filter-row">
                {['', 'PIB', 'The Hindu'].map(s => (
                    <button
                        key={s || 'all'}
                        type="button"
                        className={`filter-chip ${source === s ? 'active' : ''}`}
                        onClick={() => setSource(s)}
                    >
                        {s || 'All'}
                    </button>
                ))}
            </div>

            {loading && <p className="empty-note">Loading…</p>}
            {!loading && items.length === 0 && <p className="empty-note">No items found.</p>}

            {items.map(item => (
                <div key={item.id} className="news-row-full">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                        <span>{item.source} · {item.published_at ? new Date(item.published_at).toLocaleString() : ''}</span>
                        <BookmarkButton slug={slug} target={{ current_affairs_item_id: item.id }} note={item.title} />
                    </div>
                    <a className="news-title" href={item.source_url} target="_blank" rel="noopener noreferrer">{item.title}</a>
                    {item.summary && <p className="news-summary">{item.summary}</p>}
                </div>
            ))}
        </div>
    );
};

export default CurrentAffairsPage;
